export default {
  GET_SEATS_APPROVALS: "[seatApprovals] GET seatApprovals",
  SET_SEATS_APPROVALS: "[seatApprovals] SET seatApprovals",
  APPROVE_SEATS_APPROVAL: "[seatApprovals] POST Approve seatApprovals",
  DECLINE_SEATS_APPROVAL: "[seatApprovals] POST Decline seatApprovals",
};
